module.exports = __webpack_public_path__ + "static/media/grid_img2.7cb809f9.webp";